import $, { AxiosRequestConfig, AxiosPromise } from 'axios';
import { GetURI } from '@/plugins/utilities';
const URL = 'https://app.trustev.com/api/v2.0';
const BASEURL = `${GetURI()}/api/trustev`;
const resultCode = [
    'UNKNOWN',
    'PASS',
    'FLAG',
    'FAIL',
];

interface SimpleData {
    id?: string;
    case: string | null;
    status: number;
    comment: string;
    timeStamp: string;
    // decision: Decision;
}
export interface AdditionalData {
    acct?: string;
    dob?: Date;
    ssn?: string;
    id?: string;
}
export class Trustev {
    public name: string;
    public id?: string;
    public data: SimpleData;
    public caseType?: number;
    constructor(args: any) {
        if (args.name) {
            this.name = args.name;
        } else {
            this.name = '';
        }
        if (args.id) {
            this.id = args.id;
        } else {
            this.id = this.getToken();
        }
        if (args.data) {
            this.data = args.data;
        } else {
            this.data = ({} as SimpleData);
        }
        if (args.caseType) {
            this.caseType = args.caseType;
        } else {
            this.caseType = 0;
        }
    }
    public Send(): AxiosPromise {
        return $({
            url: BASEURL,
            method: 'POST',
            data: this.getUrls(),
        });
    }
    public ResultCode(i: number): string {
        return resultCode[i];
    }
    private getToken(): string {
        const tkn = document.querySelector('#trustSession');
        if (tkn) {
            return tkn.getAttribute('value') || 'empty';
        }
        return 'empty';
    }
    private getUrls(): AxiosRequestConfig {
        switch (this.name) {
          case 'add_case':
            let dt = {
                CaseNumber: this.data.case,
                SessionId: this.getToken(),
                CaseType: this.caseType,
            };
            let customer = {};
            if ((this.data as any).firstName) {
                customer = Object.assign(customer, { FirstName: (this.data as any).firstName });
            }
            if ((this.data as any).lastName) {
                customer = Object.assign(customer, { LastName: (this.data as any).lastName });
            }
            if ((this.data as any).phoneNumber) {
                customer = Object.assign(customer, { PhoneNumber: (this.data as any).phoneNumber });
            }
            if ((this.data as any).ssn) {
                customer = Object.assign(customer, { SocialSecurityNumber: (this.data as any).ssn });
            }
            if ((this.data as any).email) {
                customer = Object.assign(customer, { Emails: [{ EmailAddress: (this.data as any).email, IsDefault: true }] });
            }
            if ((this.data as any).dob) {
                customer = Object.assign(customer, { DateOfBirth: (this.data as any).dob });
            }
            if ((this.data as any).address) {
                const adr = { Addresses: [
                    {
                        Address1: (this.data as any).address.street,
                        City: (this.data as any).address.city,
                        PostalCode: (this.data as any).address.postal,
                        State: (this.data as any).address.region,
                        CountryCode: (this.data as any).address.country,
                        AddressType: 0,
                        FirstName: (this.data as any).firstName,
                        LastName: (this.data as any).lastName,
                    },
                ]};
                customer = Object.assign(customer, adr);
                let txn = {};
                txn = Object.assign(txn, adr);
                if ((this.data as any).email) {
                    txn = Object.assign(txn, { Emails: [{ EmailAddress: (this.data as any).email, IsDefault: true }] });
                }
                dt = Object.assign(dt, { Transaction: txn });
            }
            dt = Object.assign(dt, { Customer: customer });
            return {
                url: `${URL}/case`,
                data: dt,
                method: 'POST',
            };
          case 'decision':
            return {
                url: `${URL}/decision/${this.id}`,
                data: {},
                method: 'GET',
            };
          case 'detail':
            return {
                url: `${URL}/detaileddecision/${this.id}`,
                data: {},
                method: 'GET',
            };
          case 'add_status':
            return {
                url: `${URL}/case/${this.id}/status`,
                data: {
                    Status: this.data.status,
                    Comment: this.data.comment,
                    Timestamp: new Date().toISOString(),
                },
                method: 'POST',
            };
          case 'gen_otp':
            return {
                url: `${URL}/case/${this.data.case}/authentication/otp`,
                data: {
                    DeliveryType: this.data.status,
                    Language: 0,
                },
                method: 'POST',
            };
          case 'verify_otp':
            return {
                url: `${URL}/case/${this.data.case}/authentication/otp`,
                data: {
                    AuthURL: `${URL}/case/${this.data.case}/authentication/otp`,
                    DeliveryType: 0,
                    Language: 0,
                    Passcode: this.data.id,
                },
                method: 'PUT',
            };
          case 'risk_api':
              return {
                url: `${BASEURL}/risk`,
                data: this.data,
                method: 'POST',
              };
          case 'id_verify':
              return {
                url: this.id,
                data: {},
                method: 'GET',
              };
          default:
            return {
                url: `${URL}/token`,
                data: {},
                method: 'GET',
            };
        }
      }
}
